"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeasureCellStyle = exports.getMeasureCellFormattedValue = exports.getCellClassNames = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var numberjs_1 = require("@gooddata/numberjs");
// TODO: see if we can use existing / common function for this
function getFormattedNumber(value, format, separators) {
    var parsedNumber = value === null ? "" : typeof value === "string" ? parseFloat(value) : value;
    return numberjs_1.numberFormat(parsedNumber, format, undefined, separators);
}
// TODO: move to cell class; refactor tests
function getCellClassNames(rowIndex, columnIndex, isDrillable) {
    return classnames_1.default({
        "gd-cell-drillable": isDrillable,
    }, "gd-cell", "s-cell-" + rowIndex + "-" + columnIndex, "s-table-cell");
}
exports.getCellClassNames = getCellClassNames;
function getMeasureCellFormattedValue(value, format, separators) {
    var formattedNumber = getFormattedNumber(value, format, separators);
    var label = numberjs_1.colors2Object(formattedNumber).label;
    return label === "" ? "–" : label;
}
exports.getMeasureCellFormattedValue = getMeasureCellFormattedValue;
function getMeasureCellStyle(value, format, separators, applyColor) {
    var formattedNumber = getFormattedNumber(value, format, separators);
    var _a = numberjs_1.colors2Object(formattedNumber), backgroundColor = _a.backgroundColor, color = _a.color, label = _a.label;
    if (label === "") {
        return {
            color: "var(--gd-table-nullValueColor, var(--gd-palette-complementary-6, #94a1ad))",
            fontWeight: "bold",
        };
    }
    if (!applyColor) {
        return {};
    }
    return tslib_1.__assign(tslib_1.__assign({}, (color && { color: color })), (backgroundColor && { backgroundColor: backgroundColor }));
}
exports.getMeasureCellStyle = getMeasureCellStyle;
//# sourceMappingURL=cellUtils.js.map